import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Input = ({ className, ...rest }) => {
    return (
        <input
            className={className}
            {...rest}
            onFocus={e => {
                e.target.placeholder = '';
            }}
            onBlur={e => {
                e.target.placeholder = rest.placeholder;
            }}
        />
    );
};

Input.propTypes = {
    className: PropTypes.string.isRequired
};

export default styled(Input)`
    width: 100%;
    background-color: #fff;
    border: none;
    box-shadow: none;
    border-radius: 7px;
    font-size: 1em;
    line-height: 1.75em;
    font-weight: 300;
    color: #8f99dc;
    padding: 6px 15px;
    transition: all 200ms ease-out;

    &::-webkit-input-placeholder {
        color: #8f99dc;
    }

    &::-moz-placeholder {
        color: #8f99dc;
    }

    &::-moz-placeholder {
        color: #8f99dc;
    }

    &::-ms-input-placeholder {
        color: #8f99dc;
    }

    &:focus {
        font-size: 1em;
        line-height: 1.75em;
    }
`;
